'use client';

import React, { FC, useState } from 'react';
import { Sort, SortOrder, SortOrderType } from 'shared/types/query/ProductQuery';
import { gtmTrackEvent } from '../../../../../helpers/utils/gtm-events/gtmTrackEvent';

enum SortAttribute {
  SALE_SCORE = 'variants.attributes.saleScore',
  CREATION_DATE = 'variants.attributes.variantDate',
  PRICE = 'variants.prices.centAmount',
}

export const SortAttributes: Sort[] = [
  {
    field: SortAttribute.SALE_SCORE,
    fieldType: 'number',
    order: SortOrder.DESCENDING,
    orderType: SortOrderType.FEATURED,
  },
  {
    field: SortAttribute.SALE_SCORE,
    fieldType: 'number',
    order: SortOrder.DESCENDING,
    orderType: SortOrderType.TOP_SELLERS,
  },
  {
    field: SortAttribute.CREATION_DATE,
    fieldType: 'date',
    order: SortOrder.DESCENDING,
    orderType: SortOrderType.NEWEST,
  },
  {
    field: SortAttribute.PRICE,
    fieldType: 'number',
    order: SortOrder.ASCENDING,
    orderType: SortOrderType.PRICE_ASC,
  },
  {
    field: SortAttribute.PRICE,
    fieldType: 'number',
    order: SortOrder.DESCENDING,
    orderType: SortOrderType.PRICE_DESC,
  },
];

interface ProductListSortProps {
  sort: Sort;
  onSortChange: (sortAttributes: Sort) => void;
}

const ProductListSort: FC<ProductListSortProps> = ({ sort, onSortChange }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSortChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = SortAttributes.find((sortAttribute) => sortAttribute.orderType === event.target.value);
    gtmTrackEvent('apply_filter', {
      filter_type: 'Sort',
      selected_option: selectedValue?.orderType,
    });
    onSortChange(selectedValue as Sort);
    setIsExpanded(false);
  };

  const handleFocus = () => {
    setIsExpanded(true);
  };

  const handleBlur = () => {
    // Small delay to allow for option selection
    setTimeout(() => setIsExpanded(false), 150);
  };

  return (
    <select
      id="product-sort"
      name="product-sort"
      aria-label="Sort products by"
      aria-expanded={isExpanded}
      className="focus:border-primary focus:ring-primary/50 flex flex-1 rounded-md border border-gray-300 py-2 text-start text-sm font-normal capitalize text-gray-900 focus:outline-none focus:ring-2"
      value={sort?.orderType}
      onChange={handleSortChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      {SortAttributes.map((sortAttribute) => (
        <option
          key={`sort-${sortAttribute.orderType}`}
          value={sortAttribute.orderType}
          aria-selected={sort?.orderType === sortAttribute.orderType}
          id={`option-${sortAttribute.orderType}`}
        >
          {sortAttribute.orderType}
        </option>
      ))}
    </select>
  );
};

export default ProductListSort;
